import React, { useMemo } from "react";
import TeethRoot from "./TeethRoot";

type TeethRootsProps = {
  rotate: boolean;
  root: Array<{ width: number; variant?: any }>;
  rootDiagnoses: {
    individualRootVariants?: any[];
    forceRedColor?: boolean;
    rotate35?: boolean;
    rotateRight35?: boolean;
    hideRoot?: boolean;
  };
};

function TeethRoots({ rotate: upsideDown, root = [], rootDiagnoses }: TeethRootsProps) {
  const rootsWithVariant = useMemo(() => {
    const variants = rootDiagnoses?.individualRootVariants ?? [];
    return root.map((r, index) => ({
      ...r,
      variant: variants[index] ?? r.variant,
    }));
  }, [root, rootDiagnoses?.individualRootVariants]);
  const color = rootDiagnoses?.hideRoot
    ? "white"
    : (rootDiagnoses?.forceRedColor || rootDiagnoses?.rotate35 || rootDiagnoses?.rotateRight35)
      ? "red"
      : "black";

  const getRotation = () => {
    let rotation = 0;
    if (upsideDown) rotation += 180;
    if (rootDiagnoses?.rotate35) rotation -= 35; // Left rotation
    if (rootDiagnoses?.rotateRight35) rotation += 35; // Right rotation
    return rotation !== 0 ? `rotate(${rotation}deg)` : "rotate(0deg)";
  };

  return (
    <div
      className={`tooth-root-container ${upsideDown ? "flex flex-row-reverse" : ""} `}
      style={{ transform: getRotation() }}>
      {rootsWithVariant.map((r, index) => (
        <TeethRoot key={index} variant={r.variant} width={r.width} color={color} />
      ))}
    </div>
  );
}

export default TeethRoots;
